var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99959 11.0002H16.1696L11.2896 6.12016C10.8996 5.73016 10.8996 5.09016 11.2896 4.70016C11.3821 4.60746 11.492 4.53391 11.613 4.48373C11.7339 4.43354 11.8636 4.40771 11.9946 4.40771C12.1256 4.40771 12.2552 4.43354 12.3762 4.48373C12.4972 4.53391 12.6071 4.60746 12.6996 4.70016L19.2896 11.2902C19.3823 11.3827 19.4558 11.4926 19.506 11.6135C19.5562 11.7345 19.582 11.8642 19.582 11.9952C19.582 12.1261 19.5562 12.2558 19.506 12.3768C19.4558 12.4978 19.3823 12.6076 19.2896 12.7002L12.6996 19.2902C12.607 19.3827 12.4971 19.4562 12.3761 19.5063C12.2552 19.5564 12.1255 19.5822 11.9946 19.5822C11.8637 19.5822 11.734 19.5564 11.613 19.5063C11.4921 19.4562 11.3822 19.3827 11.2896 19.2902C11.197 19.1976 11.1236 19.0877 11.0735 18.9667C11.0234 18.8457 10.9976 18.7161 10.9976 18.5852C10.9976 18.4542 11.0234 18.3246 11.0735 18.2036C11.1236 18.0827 11.197 17.9727 11.2896 17.8802L16.1696 13.0002H4.99959C4.44959 13.0002 3.99959 12.5502 3.99959 12.0002C3.99959 11.4502 4.44959 11.0002 4.99959 11.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.929925c5d3d213ab298d935c9df3d308.svg";
export { ForwardRef as ReactComponent };